export default __webpack_public_path__ + "static/media/Twitter-Logo.5af0057c.png";